<template>
  <div class="fill-in raw-layout">
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "RawLayout"
};
</script>
